/**
 * VITE_AUTH_SURFACE_URL — oturum yoksa (401) yonlendirilecek ortak Cosmos
 * login origin'i icin zorunlu deploy yapilandirmasi.
 */
export function requireAuthSurfaceUrl(value: string | undefined): string {
  if (!value?.trim()) {
    throw new Error('VITE_AUTH_SURFACE_URL tanimli degil: ortak login origin\'i zorunludur.')
  }

  let url: URL
  try {
    url = new URL(value)
  } catch {
    throw new Error('VITE_AUTH_SURFACE_URL gecerli bir mutlak URL olmali.')
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') {
    throw new Error('VITE_AUTH_SURFACE_URL yalniz http/https origin destekler.')
  }

  if (url.username !== '' || url.password !== '') {
    throw new Error('VITE_AUTH_SURFACE_URL kimlik bilgisi iceremez.')
  }

  if (url.pathname !== '/' || url.search !== '' || url.hash !== '') {
    throw new Error('VITE_AUTH_SURFACE_URL yalniz root origin olmali (path/query/hash yasak).')
  }

  return url.origin
}
